import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../Layout";
import HeaderOrg from "../HeaderOrg";
import { Link } from "react-router-dom";
import useUserStore from "../../../utils/storeApp";

const RegistrationOrgSuccess = () => {
  const navigate = useNavigate();
  const [flag, setFlag] = useState(false);
  const { sharedObject, SetSharedObject, userSession, userRole } = useUserStore(
    (state) => ({
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
      userSession: state.userSession,
      userRole: state.userRole,
    })
  );
  const [createUser, setCreateUser] = useState(false);
  useEffect(() => {
    if (flag) navigate(flag, { replace: true });
    setCreateUser(
      userSession?.CreateUserFlag || userRole === "SES ADMINISTRATOR"
    );
  }, [flag, navigate]);
  return (
    <Layout>
      <HeaderOrg />
      <section className="layout-container">
        <div className="container ctr">
          <div className="bi-success-check">
            <i className="bi bi-check2-circle" alt="Success Checkmark"></i>
          </div>
          <div className="lg-msg">
            {/* {sharedObject?.orgActionObj?.OrganizationName}*/} Organization
            has been added successfully.
          </div>
          {createUser === true || userRole === "SES ADMINISTRATOR" ? (
            <div>
              <div className="text-size6 spacer-margin3">
                You may now add users to this organization.
              </div>
              <Link
                onClick={(el) => {
                  setFlag("/user-registration");
                }}
                className="btn btn-primary"
                role="button"
                title="Add Organization"
              >
                Add Users
              </Link>
            </div>
          ) : null}
        </div>
      </section>
    </Layout>
  );
};

export default RegistrationOrgSuccess;
